import React from 'react';

import { TabBar, Tab } from '../styled-comps';

// Presentational tab strip. `items` is [{ key, label }]; onSelect(key) fires on click.
const Tabs = ({ items, activeKey, onSelect }) => (
  <TabBar>
    {items.map(({ key, label }) => (
      <Tab key={key} $active={activeKey === key} onClick={() => onSelect(key)}>
        {label}
      </Tab>
    ))}
  </TabBar>
);

export default Tabs;
